import { P } from 'components'
import React, { useEffect, useState } from 'react'
import {
  RotateCcw,
  Save,
  X,
  Plus,
  Trash2,
  ArrowUp,
  ArrowDown,
  Layout,
  Code,
  Copy,
} from 'react-feather'
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Card,
  CardBody,
  Badge,
} from 'reactstrap'

const WIDGET_TYPES = [
  'CARD_UANG_BELANJA',
  'CARD_UANG_USAHA',
  'CARD_TALANGIN',
  'SECTION_CARDS',
  'TRANSAKSI_AKTIF',
  'ANGGOTA',
  'PENGADUAN',
  'ABSENSI',
  'EVENT',
  'CASHFLOW',
  'GENERIC_LINK',
]

const MODE_OPTIONS = [
  { value: 'primary', label: 'Primary (Outstanding/Besar)' },
  { value: 'secondary', label: 'Secondary (Normal)' },
  { value: 'compact', label: 'Compact (Padat)' },
  { value: 'tiny', label: 'Tiny (Kecil Memanjang)' },
  { value: 'tiny-square', label: 'Tiny Square (Kotak Kecil)' },
]

const COLOR_OPTIONS = [
  'red',
  'orange',
  'green',
  'blue',
  'purple',
  'indigo',
  'pink',
  'teal',
  'yellow',
]
const ICON_OPTIONS = [
  'ICON_INFORMATION',
  'ICON_REPORT',
  'ICON_HELP',
  'ICON_SETTINGS',
  'ICON_CHART',
  'ICON_TRENDING',
  'ICON_PIE',
  'ICON_SPREADSHEET',
  'ICON_HOME',
  'ICON_USER',
  'ICON_BELL',
  'ICON_CALENDAR',
  'ICON_STAR',
  'ICON_SHIELD',
  'ICON_GLOBE',
  'ICON_DOWNLOAD',
]

const WidgetSettingsForm = ({ widget, onChange }) => {
  return (
    <div className="widget-settings-form mt-2">
      <Row className="g-2 bg-light p-2 rounded border mx-0 align-items-end">
        <Col md={4}>
          <FormGroup className="mb-0">
            <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Mode
            </Label>
            <Input
              bsSize="sm"
              type="select"
              value={widget.mode || 'secondary'}
              onChange={(e) => onChange('mode', e.target.value)}
              className="border-secondary-subtle"
            >
              {MODE_OPTIONS.map((m) => (
                <option key={m.value} value={m.value}>
                  {m.label}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-0">
            <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Full Width
            </Label>
            <Input
              bsSize="sm"
              type="select"
              value={widget.fullWidth ? 'yes' : 'no'}
              onChange={(e) => onChange('fullWidth', e.target.value === 'yes')}
              className="border-secondary-subtle"
            >
              <option value="no">Tidak</option>
              <option value="yes">Ya</option>
            </Input>
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup className="mb-0">
            <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Warna Aksen
            </Label>
            <Input
              bsSize="sm"
              type="select"
              value={widget.params?.color || ''}
              onChange={(e) => onChange('params.color', e.target.value)}
              className="border-secondary-subtle"
            >
              <option value="">Default</option>
              {COLOR_OPTIONS.map((c) => (
                <option key={c} value={c}>
                  {c}
                </option>
              ))}
            </Input>
          </FormGroup>
        </Col>
      </Row>

      {widget.type === 'GENERIC_LINK' && (
        <Row className="g-2 p-2 mx-0 border rounded mt-2 border-primary-subtle bg-white shadow-sm">
          <Col md={4}>
            <FormGroup className="mb-1">
              <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase' }}>Judul</Label>
              <Input
                bsSize="sm"
                type="text"
                value={widget.params?.title || ''}
                onChange={(e) => onChange('params.title', e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-1">
              <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase' }}>URL</Label>
              <Input
                bsSize="sm"
                type="text"
                value={widget.params?.url || ''}
                placeholder="https://..."
                onChange={(e) => onChange('params.url', e.target.value)}
              />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup className="mb-1">
              <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase' }}>Ikon</Label>
              <Input
                bsSize="sm"
                type="select"
                value={widget.params?.icon || ''}
                onChange={(e) => onChange('params.icon', e.target.value)}
              >
                {ICON_OPTIONS.map((c) => (
                  <option key={c} value={c}>
                    {c}
                  </option>
                ))}
              </Input>
            </FormGroup>
          </Col>
          <Col md={12}>
            <FormGroup className="mb-0">
              <Label className="text-muted fw-bold mb-1" style={{ fontSize: '10px', textTransform: 'uppercase' }}>Deskripsi</Label>
              <Input
                bsSize="sm"
                type="text"
                value={widget.params?.description || ''}
                onChange={(e) => onChange('params.description', e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
      )}
    </div>
  )
}

const TemplateConfigModal = ({ isOpen, toggle, profileTemplate, userId }) => {
  const [config, setConfig] = useState('')
  const [activeTab, setActiveTab] = useState('visual')

  // Visual Builder State
  const [categories, setCategories] = useState([])
  const [uncategorizedWidgets, setUncategorizedWidgets] = useState([])
  const [gridSetting, setGridSetting] = useState(4)

  useEffect(() => {
    if (isOpen) {
      if (profileTemplate) {
        const templateObj = {
          name: profileTemplate.name || 'HOMEBEAVERS',
          settings: profileTemplate.settings || { grid: 4 }
        };
        if (profileTemplate.categories) templateObj.categories = profileTemplate.categories;
        if (profileTemplate.widgets) templateObj.widgets = profileTemplate.widgets;

        const wrapProfile = {
          userId: userId || 236,
          template: JSON.stringify(templateObj, null, 2)
        };
        setConfig(JSON.stringify(wrapProfile, null, 2))
        syncToVisual(wrapProfile)
      } else {
        loadDefault()
      }
    }
  }, [isOpen, profileTemplate, userId])

  const loadDefault = () => {
    import('../../config/templateConfig').then((module) => {
      const templateObj = module.JSON_TEMPLATES.homeweavers;
      const wrapProfile = {
        userId: userId || 236,
        template: JSON.stringify(templateObj, null, 2)
      };
      setConfig(JSON.stringify(wrapProfile, null, 2))
      syncToVisual(wrapProfile)
    })
  }

  const syncToVisual = (parsedConfig) => {
    try {
      let actualTemplate;
      
      if (parsedConfig && parsedConfig.template && typeof parsedConfig.template === 'string') {
        actualTemplate = JSON.parse(parsedConfig.template);
      } else if (parsedConfig && parsedConfig.homeweavers) {
        actualTemplate = parsedConfig.homeweavers;
      } else {
        actualTemplate = parsedConfig;
      }

      if (actualTemplate) {
        setCategories(actualTemplate.categories || [])
        setUncategorizedWidgets(actualTemplate.widgets || [])
        setGridSetting(actualTemplate.settings?.grid || 4)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const syncToJson = () => {
    try {
      const templateObj = {
        name: profileTemplate?.name || 'HOMEBEAVERS',
        settings: { grid: parseInt(gridSetting, 10) || 4 }
      };

      if (categories.length > 0) {
        templateObj.categories = categories;
      }
      if (uncategorizedWidgets.length > 0) {
        templateObj.widgets = uncategorizedWidgets;
      }

      const payload = {
        userId: userId || 236,
        template: JSON.stringify(templateObj, null, 2)
      };
      return JSON.stringify(payload, null, 2)
    } catch (e) {
      console.error(e)
      return config
    }
  }

  const toggleTab = (tab) => {
    if (activeTab === tab) return

    if (tab === 'visual') {
      // Sync from JSON to Visual
      try {
        const parsed = JSON.parse(config)
        syncToVisual(parsed)
        setActiveTab(tab)
      } catch (e) {
        alert(
          'JSON tidak valid. Harap perbaiki sebelum pindah ke Visual Builder.',
        )
      }
    } else {
      // Sync from Visual to JSON
      const newConfig = syncToJson()
      setConfig(newConfig)
      setActiveTab(tab)
    }
  }

  const handleCopy = () => {
    try {
      let finalConfig = config
      if (activeTab === 'visual') {
        finalConfig = syncToJson()
      }

      navigator.clipboard.writeText(finalConfig)
      alert('Payload JSON berhasil disalin ke clipboard!')
    } catch (error) {
      alert('Error: Gagal menyalin payload.')
      console.error('Copy Error:', error)
    }
  }

  const handleReset = () => {
    if (window.confirm('Anda yakin ingin mereset ke default?')) {
      const resetPayload = {
        userId: userId || 236,
        template: null
      };
      setConfig(JSON.stringify(resetPayload, null, 2));
      setActiveTab('json');
    }
  }

  // --- Visual Builder Handlers ---
  const addCategory = () => {
    setCategories([...categories, { title: 'Kategori Baru', widgets: [] }])
  }

  const addUncategorizedWidget = () => {
    setUncategorizedWidgets([
      ...uncategorizedWidgets,
      {
        type: 'GENERIC_LINK',
        mode: 'secondary',
        params: { title: 'New Menu', description: '' },
      },
    ])
  }

  const removeUncategorizedWidget = (wIdx) => {
    const newW = [...uncategorizedWidgets]
    newW.splice(wIdx, 1)
    setUncategorizedWidgets(newW)
  }

  const moveUncategorizedWidget = (wIdx, dir) => {
    if (wIdx + dir < 0 || wIdx + dir >= uncategorizedWidgets.length) return
    const newW = [...uncategorizedWidgets]
    const temp = newW[wIdx]
    newW[wIdx] = newW[wIdx + dir]
    newW[wIdx + dir] = temp
    setUncategorizedWidgets(newW)
  }

  const updateUncategorizedWidget = (wIdx, field, value) => {
    const newW = [...uncategorizedWidgets]
    const widget = newW[wIdx]
    if (field.startsWith('params.')) {
      const pField = field.split('.')[1]
      if (!widget.params) widget.params = {}
      widget.params[pField] = value
    } else {
      widget[field] = value
      if (field === 'type' && value === 'GENERIC_LINK' && !widget.params) {
        widget.params = {
          title: 'New Link',
          color: 'blue',
          icon: 'ICON_INFORMATION',
        }
      }
    }
    setUncategorizedWidgets(newW)
  }

  const removeCategory = (cIdx) => {
    if (
      window.confirm('Hapus kategori ini beserta semua widget di dalamnya?')
    ) {
      const newC = [...categories]
      newC.splice(cIdx, 1)
      setCategories(newC)
    }
  }

  const moveCategory = (cIdx, dir) => {
    if (cIdx + dir < 0 || cIdx + dir >= categories.length) return
    const newC = [...categories]
    const temp = newC[cIdx]
    newC[cIdx] = newC[cIdx + dir]
    newC[cIdx + dir] = temp
    setCategories(newC)
  }

  const updateCategoryTitle = (cIdx, newTitle) => {
    const newC = [...categories]
    newC[cIdx].title = newTitle
    setCategories(newC)
  }

  const addWidget = (cIdx) => {
    const newC = [...categories]
    newC[cIdx].widgets.push({
      type: 'GENERIC_LINK',
      mode: 'secondary',
      params: { title: 'New Menu', description: '' },
    })
    setCategories(newC)
  }

  const removeWidget = (cIdx, wIdx) => {
    const newC = [...categories]
    newC[cIdx].widgets.splice(wIdx, 1)
    setCategories(newC)
  }

  const moveWidget = (cIdx, wIdx, dir) => {
    if (wIdx + dir < 0 || wIdx + dir >= categories[cIdx].widgets.length) return
    const newC = [...categories]
    const temp = newC[cIdx].widgets[wIdx]
    newC[cIdx].widgets[wIdx] = newC[cIdx].widgets[wIdx + dir]
    newC[cIdx].widgets[wIdx + dir] = temp
    setCategories(newC)
  }

  const updateWidget = (cIdx, wIdx, field, value) => {
    const newC = [...categories]
    const widget = newC[cIdx].widgets[wIdx]
    if (field.startsWith('params.')) {
      const pField = field.split('.')[1]
      if (!widget.params) widget.params = {}
      widget.params[pField] = value
    } else {
      widget[field] = value
      // Set defaults for generic link to avoid empty states
      if (field === 'type' && value === 'GENERIC_LINK' && !widget.params) {
        widget.params = {
          title: 'New Link',
          color: 'blue',
          icon: 'ICON_INFORMATION',
        }
      }
    }
    setCategories(newC)
  }

  return (
    <Modal
      isOpen={isOpen}
      size="xl"
      className="template-config-modal"
      backdrop="static"
      centered
      style={{ maxWidth: '1140px', width: '100%', margin: '0 auto' }}
      data-testid="template-config-modal"
    >
      <ModalHeader className="bg-primary text-white" toggle={toggle} close={<button className="btn-close btn-close-white" onClick={toggle} data-testid="template-config-close"></button>}>
        <div className="d-flex align-items-center">
          <Layout size={20} className="me-2" />
          <P className="mb-0 text-white" size="large">
            Edit Template Configuration
          </P>
        </div>
      </ModalHeader>

      <ModalBody className="p-0 bg-light">
        <Nav tabs className="px-3 pt-3 bg-white border-bottom">
          <NavItem>
            <NavLink
              className={`cursor-pointer d-flex align-items-center pb-3 ${activeTab === 'visual' ? 'active fw-bold border-bottom-primary' : 'text-muted'}`}
              onClick={() => toggleTab('visual')}
              data-testid="template-config-tab-visual"
              style={
                activeTab === 'visual'
                  ? { borderBottom: '3px solid #0d6efd', color: '#0d6efd', cursor: 'pointer' }
                  : { cursor: 'pointer' }
              }
            >
              <Layout size={16} className="me-2" /> Visual Builder
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`cursor-pointer d-flex align-items-center pb-3 ${activeTab === 'json' ? 'active fw-bold border-bottom-primary' : 'text-muted'}`}
              onClick={() => toggleTab('json')}
              data-testid="template-config-tab-json"
              style={
                activeTab === 'json'
                  ? { borderBottom: '3px solid #0d6efd', color: '#0d6efd', cursor: 'pointer' }
                  : { cursor: 'pointer' }
              }
            >
              <Code size={16} className="me-2" /> JSON Editor
            </NavLink>
          </NavItem>
        </Nav>

        <TabContent
          activeTab={activeTab}
          className="p-4"
          style={{ minHeight: '60vh', maxHeight: '70vh', overflowY: 'auto' }}
        >
          <TabPane tabId="visual">
            <div className="d-flex justify-content-between align-items-center mb-4 bg-white p-3 rounded shadow-sm border">
              <div className="d-flex align-items-center gap-3">
                <Label className="mb-0 fw-bold">Grid Layout (Columns):</Label>
                <Input
                  type="select"
                  style={{ width: '100px' }}
                  value={gridSetting}
                  onChange={(e) => setGridSetting(e.target.value)}
                >
                  <option value="1">1 Col</option>
                  <option value="2">2 Cols</option>
                  <option value="3">3 Cols</option>
                  <option value="4">4 Cols</option>
                </Input>
              </div>
              <div className="d-flex gap-2">
                <Button
                  color="secondary"
                  outline
                  onClick={addUncategorizedWidget}
                  className="d-flex align-items-center"
                  data-testid="template-config-add-widget"
                >
                  <Plus size={16} className="me-1" /> Tambah Widget Independen
                </Button>
                <Button
                  color="primary"
                  onClick={addCategory}
                  className="d-flex align-items-center"
                  data-testid="template-config-add-category"
                >
                  <Plus size={16} className="me-1" /> Tambah Kategori
                </Button>
              </div>
            </div>

            {uncategorizedWidgets.length > 0 && (
              <div className="mb-5">
                <h6 className="fw-bold mb-3 d-flex align-items-center text-secondary">
                  <Layout size={16} className="me-2" /> Widget Tanpa Kategori
                  (Berdiri Sendiri)
                </h6>
                <Row className="g-3">
                  {uncategorizedWidgets.map((w, wIdx) => (
                    <Col
                      xs={12}
                      lg={w.fullWidth ? 12 : 6}
                      key={`uncat-${wIdx}`}
                    >
                      <Card
                        className="h-100 shadow-sm border position-relative"
                        style={{
                          transition: 'all 0.2s',
                          backgroundColor: '#fdfdfd',
                        }}
                        data-testid={`template-config-widget-${wIdx}`}
                      >
                        <CardBody className="p-3">
                          <div className="d-flex justify-content-between align-items-center mb-0 border-bottom pb-2">
                            <div className="d-flex align-items-center gap-2 flex-grow-1">
                              <div className="bg-light text-secondary rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: '24px', height: '24px', fontSize: '12px' }}>
                                {wIdx + 1}
                              </div>
                              <Input
                                type="select"
                                value={w.type || ''}
                                onChange={(e) =>
                                  updateUncategorizedWidget(
                                    wIdx,
                                    'type',
                                    e.target.value,
                                  )
                                }
                                className="fw-bold border-0 bg-transparent shadow-none px-1"
                                style={{ flexGrow: 1, minWidth: '150px' }}
                              >
                                {WIDGET_TYPES.map((t) => (
                                  <option key={t} value={t}>
                                    {t}
                                  </option>
                                ))}
                              </Input>
                            </div>
                            <div className="d-flex gap-1 ms-2">
                              <Button
                                size="sm"
                                color="light"
                                className="px-2"
                                onClick={() =>
                                  moveUncategorizedWidget(wIdx, -1)
                                }
                                disabled={wIdx === 0}
                                title="Move Up"
                              >
                                <ArrowUp size={14} />
                              </Button>
                              <Button
                                size="sm"
                                color="light"
                                className="px-2"
                                onClick={() => moveUncategorizedWidget(wIdx, 1)}
                                disabled={
                                  wIdx === uncategorizedWidgets.length - 1
                                }
                                title="Move Down"
                              >
                                <ArrowDown size={14} />
                              </Button>
                              <Button
                                size="sm"
                                color="danger"
                                className="ms-1 px-2 border-0 bg-danger-subtle text-danger"
                                onClick={() => removeUncategorizedWidget(wIdx)}
                                title="Hapus"
                              >
                                <Trash2 size={14} />
                              </Button>
                            </div>
                          </div>

                          <WidgetSettingsForm 
                            widget={w} 
                            onChange={(field, value) => updateUncategorizedWidget(wIdx, field, value)} 
                          />
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            )}

            {categories.length === 0 && uncategorizedWidgets.length === 0 ? (
              <div className="text-center py-5 text-muted border rounded bg-white">
                Belum ada widget. Klik 'Tambah Kategori' atau 'Tambah Widget
                Independen' untuk memulai.
              </div>
            ) : (
              categories.map((cat, cIdx) => (
                <div
                  key={cIdx}
                  className="mb-4 bg-white p-3 rounded border shadow-sm"
                  style={{ borderTop: '4px solid #0d6efd !important' }}
                  data-testid={`template-config-category-${cIdx}`}
                >
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <div className="d-flex align-items-center gap-2 flex-grow-1 me-3">
                      <Layout size={18} className="text-secondary" />
                      <Input
                        value={cat.title}
                        onChange={(e) =>
                          updateCategoryTitle(cIdx, e.target.value)
                        }
                        className="fw-bold border-0 bg-light"
                        placeholder="Nama Kategori..."
                        style={{ fontSize: '18px' }}
                      />
                    </div>
                    <div className="d-flex gap-2">
                      <Button
                        size="sm"
                        color="light"
                        onClick={() => moveCategory(cIdx, -1)}
                        disabled={cIdx === 0}
                        title="Pindah Atas"
                      >
                        <ArrowUp size={14} />
                      </Button>
                      <Button
                        size="sm"
                        color="light"
                        onClick={() => moveCategory(cIdx, 1)}
                        disabled={cIdx === categories.length - 1}
                        title="Pindah Bawah"
                      >
                        <ArrowDown size={14} />
                      </Button>
                      <Button
                        size="sm"
                        color="primary"
                        outline
                        onClick={() => addWidget(cIdx)}
                        className="d-flex align-items-center"
                      >
                        <Plus size={14} className="me-1" /> Tambah Widget
                      </Button>
                      <Button
                        size="sm"
                        color="danger"
                        outline
                        onClick={() => removeCategory(cIdx)}
                        title="Hapus Kategori"
                      >
                        <Trash2 size={14} />
                      </Button>
                    </div>
                  </div>

                  {cat.widgets?.length === 0 ? (
                    <div className="text-center py-4 bg-light rounded text-muted small border border-dashed">
                      Kategori ini kosong. Tambahkan widget.
                    </div>
                  ) : (
                    <Row className="g-3">
                      {cat.widgets?.map((w, wIdx) => (
                        <Col xs={12} lg={w.fullWidth ? 12 : 6} key={wIdx}>
                          <Card
                            className="h-100 shadow-sm border position-relative"
                            style={{
                              transition: 'all 0.2s',
                              backgroundColor: '#fcfcfc',
                            }}
                            data-testid={`template-config-widget-${cIdx}-${wIdx}`}
                          >
                            <CardBody className="p-3">
                              <div className="d-flex justify-content-between align-items-center mb-0 border-bottom pb-2">
                                <div className="d-flex align-items-center gap-2 flex-grow-1">
                                  <div className="bg-light text-secondary rounded-circle d-flex align-items-center justify-content-center fw-bold" style={{ width: '24px', height: '24px', fontSize: '12px' }}>
                                    {wIdx + 1}
                                  </div>
                                  <Input
                                    type="select"
                                    value={w.type || ''}
                                    onChange={(e) =>
                                      updateWidget(
                                        cIdx,
                                        wIdx,
                                        'type',
                                        e.target.value,
                                      )
                                    }
                                    className="fw-bold border-0 bg-transparent shadow-none px-1"
                                    style={{ flexGrow: 1, minWidth: '150px' }}
                                  >
                                    {WIDGET_TYPES.map((t) => (
                                      <option key={t} value={t}>
                                        {t}
                                      </option>
                                    ))}
                                  </Input>
                                </div>
                                <div className="d-flex gap-1 ms-2">
                                  <Button
                                    size="sm"
                                    color="light"
                                    className="px-2"
                                    onClick={() => moveWidget(cIdx, wIdx, -1)}
                                    disabled={wIdx === 0}
                                    title="Move Up"
                                  >
                                    <ArrowUp size={14} />
                                  </Button>
                                  <Button
                                    size="sm"
                                    color="light"
                                    className="px-2"
                                    onClick={() => moveWidget(cIdx, wIdx, 1)}
                                    disabled={wIdx === cat.widgets.length - 1}
                                    title="Move Down"
                                  >
                                    <ArrowDown size={14} />
                                  </Button>
                                  <Button
                                    size="sm"
                                    color="danger"
                                    className="ms-1 px-2 border-0 bg-danger-subtle text-danger"
                                    onClick={() => removeWidget(cIdx, wIdx)}
                                    title="Hapus"
                                  >
                                    <Trash2 size={14} />
                                  </Button>
                                </div>
                              </div>

                              <WidgetSettingsForm 
                                widget={w} 
                                onChange={(field, value) => updateWidget(cIdx, wIdx, field, value)} 
                              />
                            </CardBody>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                </div>
              ))
            )}
          </TabPane>

          <TabPane tabId="json">
            <div
              className="mb-4 bg-light p-3 rounded border text-muted"
              style={{ fontSize: '13px' }}
            >
              <h6 className="fw-bold text-dark mb-2">
                <Code size={16} className="me-1" /> Panduan Konfigurasi JSON
              </h6>
              <p className="mb-2">
                Struktur disesuaikan dengan Postman Payload yang melampirkan <code>userId</code> dan property <code>template</code> (sebagai string JSON).
                Anda bebas menyusun <strong>Kategori Baris</strong>{' '}
                (array <code>categories</code>) atau{' '}
                <strong>Tanpa Kategori</strong> (array <code>widgets</code>).
              </p>
              <Row>
                <Col md={6}>
                  <strong className="text-dark">
                    Struktur API Payload:
                  </strong>
                  <pre
                    className="bg-white p-2 mt-1 mb-0 border rounded"
                    style={{ fontSize: '11px', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
                  >
                    {`{
  "userId": 236,
  "template": "{\\n  \\"name\\": \\"DEFAULT\\",\\n  \\"settings\\": { \\"grid\\": 4 },\\n  \\"categories\\": [\\n    {\\n      \\"title\\": \\"Nama Baris\\",\\n      \\"widgets\\": [ { \\"type\\": \\"GENERIC_LINK\\" } ]\\n    }\\n  ]\\n}"
}`}
                  </pre>
                </Col>
                <Col md={6}>
                  <strong className="text-dark">
                    Properti Widget Pilihan:
                  </strong>
                  <ul className="mt-1 ps-3 mb-0">
                    <li className="mb-1">
                      <code>type</code>:{' '}
                      <span
                        className="text-primary fw-bold"
                        style={{ fontSize: '11px' }}
                      >
                        CARD_UANG_BELANJA, EVENT, GENERIC_LINK, dll.
                      </span>
                    </li>
                    <li className="mb-1">
                      <code>mode</code>:{' '}
                      <span
                        className="text-success fw-bold"
                        style={{ fontSize: '11px' }}
                      >
                        primary, secondary, compact, tiny.
                      </span>
                    </li>
                    <li className="mb-1">
                      <code>fullWidth</code>:{' '}
                      <span
                        className="text-info fw-bold"
                        style={{ fontSize: '11px' }}
                      >
                        true / false.
                      </span>
                    </li>
                    <li>
                      <code>params</code>:{' '}
                      <span
                        className="text-warning fw-bold"
                        style={{ fontSize: '11px' }}
                      >
                        {'{ title, description, url, icon, color }'}
                      </span>{' '}
                      <br />
                      <span className="ms-2">(Dapat digunakan di semua tipe widget).</span>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>

            <FormGroup>
              <Label for="configEditor" className="fw-bold text-dark">
                Source Code JSON
              </Label>
              <Input
                id="configEditor"
                type="textarea"
                value={config}
                onChange={(e) => setConfig(e.target.value)}
                rows={25}
                style={{
                  fontFamily: 'monospace',
                  fontSize: '13px',
                  backgroundColor: '#1e1e1e',
                  color: '#d4d4d4',
                  borderRadius: '6px',
                  padding: '16px',
                }}
                placeholder="Paste your JSON configuration here..."
              />
            </FormGroup>
            <div className="mt-2 text-muted small">
              <strong>Catatan:</strong> Pastikan format JSON valid agar dapat
              di-render dengan benar.
            </div>
          </TabPane>
        </TabContent>
      </ModalBody>

      <ModalFooter className="bg-light border-top">
        <Button color="secondary" onClick={toggle} outline className="px-4" data-testid="template-config-cancel">
          <X size={16} className="me-1" /> Batal
        </Button>
        <Button
          color="danger"
          onClick={handleReset}
          outline
          className="me-auto px-3"
          data-testid="template-config-reset"
        >
          <RotateCcw size={16} className="me-1" /> Reset Default
        </Button>
        <Button color="primary" onClick={handleCopy} className="px-5 shadow-sm" data-testid="template-config-copy">
          <Copy size={16} className="me-1" /> Salin Payload JSON
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default TemplateConfigModal
